import type { DefaultTheme } from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";

type ThemeProps = { theme: DefaultTheme };

/**
 * Theme-aware colours for controls whose styles predate the theme (dropdowns, menus): the active
 * theme's token, or the identical light value when rendered outside a ThemeProvider. Each resolves
 * to the same colour it replaced in the light theme, so light screens don't change.
 */
export const themedColor = {
  surface: ({ theme }: ThemeProps): string => theme.colors?.background?.primary ?? rawColors.structural.white,
  stroke: ({ theme }: ThemeProps): string => theme.colors?.border?.stroke ?? rawColors.stroke[200],
  text: ({ theme }: ThemeProps): string => theme.colors?.text?.primary ?? rawColors.text.highEmphasis,
  textSecondary: ({ theme }: ThemeProps): string => theme.colors?.text?.secondary ?? rawColors.text.mediumEmphasis,
  textTertiary: ({ theme }: ThemeProps): string => theme.colors?.text?.tertiary ?? rawColors.text.lowEmphasis,
  hover: ({ theme }: ThemeProps): string => theme.colors?.background?.tertiary ?? rawColors.structural[100],
};
